import { Component } from '@angular/core';

@Component({
  selector: 'app-edit-document-section-image-upload',
  standalone: false,
  templateUrl: './edit-document-section-image-upload.component.html',
})
export class EditDocumentSectionImageUploadComponent {}
